export default "__VITE_ASSET__BI2$Sdkh__"